import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Quotes = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'quotes' */
  './Quotes'
))

export function AsyncQuotes(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Quotes..." />}>
      <Quotes {...props} />
    </Suspense>
  )
}

export default AsyncQuotes
